import {Location} from 'src/common/map/Location';
import GameConfig from 'src/game/GameConfig';
import {Sprite} from 'pixi.js';
import {PointerMoveAction} from 'src/Action';

export class Pointer {
    private actionAt: number;

    public constructor(public sprite: Sprite, private action: PointerMoveAction) {
        this.actionAt = Date.now();
    }

    public setAction(action: PointerMoveAction): void {
        this.action = action;
        this.actionAt = Date.now();
    }

    public tick(): void {
        const tile = this.getLocation().add(new Location(1, 1));
        const screenLoc = Location.fromLoc(tile).multN(GameConfig.tileSize);
        this.sprite.position.set(screenLoc.x, screenLoc.y);
    }

    private getLocation(): Location {
        const location = Location.fromLoc(this.action.location);
        const velocity = Location.fromLoc(this.action.velocity);
        const dt = (Date.now() - this.actionAt) / 1000;
        return location.add(velocity.multN(dt));
    }
}



// WEBPACK FOOTER //
// ./src/Pixi/Pointer.ts